import { useNotifications } from '@/hooks/useNotifications';
import { fetchNotifications } from '@/store/api/notifications.api';
import { useAppSelector } from '@/store/hooks';
import { selectAuthToken } from '@/store/selectors/auth.selectors';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const NotificationFetcher = () => {
  const { addNotifications, clearNotifications } = useNotifications();
  const location = useLocation();
  const token = useAppSelector(selectAuthToken);

  useEffect(() => {
    if (!token) return;

    const load = async () => {
      const res = await fetchNotifications();

      if (res.length) {
        addNotifications(res);
      } else {
        clearNotifications();
      }
    };

    load();
  }, [location.pathname, token]);

  return null;
};
